"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import React from "react";
import _ from "underscore";
import Account from "../../api/account";
import LoadTable from "./load_table";
import LoadSearchForm from "./load_search_form";
import CarrierName from "../carrier_name";
function maybeShowAllCarrierNotification(props, state) {
  if (state.fell_back_to_any_carrier) {
    return /* @__PURE__ */ React.createElement("div", { className: "alert-box--highlight" }, "No matches found for ", /* @__PURE__ */ React.createElement(CarrierName, { carrierID: props.carrier.id }), ", searching all ", Account.carrierTermLower(), "s.");
  }
}
function loadTable(props, state) {
  if (!_.isEmpty(state.loads) || state.searched) {
    return /* @__PURE__ */ React.createElement("div", { className: "load-assigner__search-results" }, maybeShowAllCarrierNotification(props, state), /* @__PURE__ */ React.createElement("h3", null, "Search Results"), /* @__PURE__ */ React.createElement(
      LoadTable,
      {
        items: state.loads,
        loadsNotFromEmailCarrier: props.loadsNotFromEmailCarrier,
        selectedLoadStateId: props.selectedLoadStateId,
        highlightedLoads: props.highlightedLoads,
        onSelectionChange: props.onSelectionChange,
        highlightChanged: props.highlightReference
      }
    ));
  }
}
function possibleLoadMessage(props) {
  var message;
  if (props.multiCarrier) {
    message = `We couldn't find any loads in this document. First, use the search below to look for loads or click "Create an exception" below to report a problem. Next, assign a ` + Account.carrierTermLower() + ".";
  } else {
    message = `We couldn't find any loads in this document. Use the search below to look for loads or click "Create an exception" below to report a problem.`;
  }
  if (props.highlightedLoads.length === 0) {
    return /* @__PURE__ */ React.createElement("div", { className: "alert-box--progress" }, message);
  }
}
export default class extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", { loads: [], searched: false });
    __publicField(this, "onSearch", (terms) => {
      this.setState({ searching: true });
      this.props.searcher(terms).then((data) => {
        this.setState({
          searching: false,
          loads: data.loads,
          fell_back_to_any_carrier: data.fell_back_to_any_carrier,
          searched: true
        });
      });
    });
    __publicField(this, "onCancel", () => {
      this.setState({ searching: false, loads: [] });
      this.props.onCancel();
    });
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: "load-assigner__search-area" }, possibleLoadMessage(this.props), /* @__PURE__ */ React.createElement("p", { className: "load-assigner__search-instructions" }, "Search for loads to assign."), /* @__PURE__ */ React.createElement(
      LoadSearchForm,
      {
        carrier: this.props.carrier,
        searching: this.state.searching,
        onSearch: this.onSearch,
        onCancel: this.onCancel
      }
    ), loadTable(this.props, this.state));
  }
}
